<template>
  <DatePicker v-model="data" v-bind="$attrs"></DatePicker>
</template>
<script>
  import { util } from '@/libs'
  export default {
    model: { prop: 'value', event: 'change' },
    props: {
      value: String
    },
    computed: {
      data: {
        get() {
          return this.value ? Date.new(this.value) : null
        },
        set(val) {
          this.$emit('change', val ? util.formatDate(val, this.$attrs.format) : null)
        }
      }
    },
  }
</script>